export default "<div>{{ GetRapportIncidentTypeDetail(id) }}</div>";